import { AxiosResponse } from "axios";

import {
  ITriggeredWorkflow,
  IWorkflowRun,
  IWorkflowStepState,
} from "../../@types/admin/AdminWorkflow";
import { api } from "../api";

/**
 * Workflows admin page (EN-5167), migrated from the Retool Workflows app
 * (`moduleWorkflows`). All three of its queries hit the pMp DB directly; they
 * are ported into these endpoints so Retool and the portal read the same rows
 * during the transition.
 */
export const workflowsService = {
  /**
   * Patients with a triggered workflow. Omit `patientId` for the whole set —
   * the page sends nothing, the embedded per-patient panel sends an ID.
   */
  async getTriggeredWorkflows(
    patientId?: number
  ): Promise<AxiosResponse<ITriggeredWorkflow[]>> {
    // The per-patient case has its own route (EN-5170), for the same reason as
    // the Alerts panel: `patients:access` must reach one patient's runs without
    // also opening an unfiltered read of every triggered run in the region.
    if (patientId !== undefined) {
      return api.get<ITriggeredWorkflow[]>(
        `/Retool/Workflows/Patients/${patientId}`
      );
    }
    return api.get<ITriggeredWorkflow[]>("/Retool/Workflows");
  },

  /** One patient's workflow runs, newest first. */
  async getPatientWorkflowHistory(
    patientId: number
  ): Promise<AxiosResponse<IWorkflowRun[]>> {
    return api.get<IWorkflowRun[]>(
      `/Retool/Workflows/Patients/${patientId}/History`
    );
  },

  /** The executed steps of one run, oldest first. */
  async getRunSteps(
    workflowPatientStateId: string
  ): Promise<AxiosResponse<IWorkflowStepState[]>> {
    return api.get<IWorkflowStepState[]>(
      `/Retool/Workflows/Runs/${workflowPatientStateId}/Steps`
    );
  },
};
